<template>
    <div>
        <table :class="tableClass">
            <tr v-for="(rating, key) in existingRatings" :key="key">
                <td>{{ key | ucWords }}</td>
                <td class="pl-3">
                    <RatingChartStars :editable="editable" :max-rating="maxRating" :rating="rating" :key="key" @change="$emit('change', key, $event)" />
                </td>
                <td class="rating-value pl-2">{{ rating }}</td>
            </tr>
            
            <tr v-if="!editable">
                <th>Overall</th>
                <td class="pl-3">
                    <RatingChartStars :rating="overallRating" />
                </td>
                <td class="rating-value pl-2">{{ overallRating }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
import RatingChartStars from './RatingChartStars'

export default {
    name: 'RatingChart',
    components: {
        RatingChartStars,
    },
    props: {
        ratings: {
            type: Object,
            required: true,
        },
        tableClass: {
            type: [String,Object,Array],
        },
        editable: {
            type: Boolean,
            default() {
                return false
            }
        },
        maxRating: {
            type: Number,
            default() {
                return 5
            },
        },
    },
    computed: {
        existingRatings() {
            return Object.keys(this.ratings)
                .reduce((obj, key) => {
                    (this.editable || this.ratings[key] !== null) && (obj[key] = this.ratings[key])
                    
                    return obj
                }, {})
        },
        overallRating() {
            let ratingSum = Object.values(this.ratings).reduce((acc, rating) => parseFloat(acc) + parseFloat(rating || 0), 0)
            let ratingLength = Object.values(this.existingRatings).length
            
            return Number(this.constrainRange(ratingSum / ratingLength).toFixed(2))
        },
    },
    methods: {
        constrainRange(value) {
            return Math.min(Math.max(value, 0), this.maxRating)
        },
    }
};
</script>

<style lang="scss">
.rating-value {
    font-size: 9px;
    font-weight: bold;
    font-style: italic;
}
</style>